import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavController, NavParams, Slide, Slides } from 'ionic-angular';
import { find } from 'lodash';
import { PhcApp, PhcAppMenu, PhcAppSubmenu } from '../../classes/phc-app/phc-app';
import { WpProvider } from "../../providers/wp/wp";
import { PhcLinkServiceProvider } from '../../providers/phc-link-service/phc-link-service';
import { AnalyticsProvider } from '../../providers/analytics/analytics';
import { KioskServiceProvider } from '../../providers/kiosk-service/kiosk-service';
import { AppConfigProvider } from '../../providers/app-config/app-config';

interface SlideTrack {
  [key: string]: Slides
}

/**
 * Generated class for the SubmenuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-submenu',
  templateUrl: 'submenu.html',
})
export class SubmenuPage implements OnInit, OnDestroy {

  videoWidth = 0;
  videoHeight = 0;
  sliderBackup;
  menu;
  menuId;
  homePage = false;
  phcApp: PhcApp;
  slides: SlideTrack = {};

  showSlideshow = false;
  slideshowTimeout;
  slideshowTimeoutDelay = 4000;

  get slideshowEnabled() {
    return this.kiosk.isKiosk && this.homePage && this.showSlideshow;
  }

  get menus(): Array<PhcAppSubmenu|PhcAppMenu> {
    return [
      this.menu,
      ...this.menu.submenus.map(sub => sub),
    ];
  }


  activateBanner(banner) {
    if (!banner || !banner.link) {
      return;
    }
    console.log('activating...');
    this.analytics.trackItem(banner.link);
    this.linkService.activateLink(banner.link, this.navCtrl);
  }

  resetSlideshow() {
    this.showSlideshow = false;
    clearTimeout(this.slideshowTimeout);
    this.slideshowTimeout = setTimeout(() => {
      this.showSlideshow = true;
    }, this.slideshowTimeoutDelay);
  }

  constructor(
    public appConfig: AppConfigProvider,
    private navParams: NavParams,
    private wp: WpProvider,
    private linkService: PhcLinkServiceProvider,
    private navCtrl: NavController,
    private analytics: AnalyticsProvider,
    private kiosk: KioskServiceProvider
  ) {

    this.phcApp = wp.app;
    this.menu = navParams.get('menu');
    this.menuId = navParams.get('menuId');
    this.homePage = navParams.get('homePage');

    this.sliderBackup = this.kiosk.startSliders.subscribe(() => {
      console.log('SLIDERS RESTARTING');
      Object.keys(this.slides).forEach(key => {
        setTimeout(() => {
          const slide = this.slides[key];
          slide.update();
          setTimeout(() => {
            this.cycleSlides(slide);
          }, 10)
        }, 10);
      })
    });

  }

  ionViewDidEnter() {
    if (this.homePage && this.wp.queuedUpdate) {
      window.location.reload();
    }
  }

  initSlider(slides: Slides, key = this.menu.id) {
    const bannerIndex = (slides.getActiveIndex() - 1) % this.menu.banners.length;
    slides.stopAutoplay();
    slides.autoplay = this.menu.banners[bannerIndex].duration;
    slides.startAutoplay();
    this.slides[key] = slides;
  }

  ngOnInit() {

    setTimeout(() => {
      const rows = Array.prototype.slice.apply(document.querySelectorAll('.content-row'));
      const boundingRects = rows.map(el => el.getBoundingClientRect());
      const totalHeight = document.querySelector('page-submenu .scroll-content').getBoundingClientRect().height;
      const currHeight = boundingRects.reduce((total, currRect) => total + currRect.height, 0);
      if (totalHeight > currHeight) {
        rows[rows.length - 1].style.height = (totalHeight - currHeight) + boundingRects[boundingRects.length - 1].height + 'px';
      }
    }, 1000);

    this.videoWidth = window.innerWidth;
    this.videoHeight = window.innerWidth * 9 / 16;
    if (!this.menu) {
      if(this.menuId) {
        this.menu = this.phcApp.getMenu(this.menuId);
      }else{
        const firstInd = this.phcApp.home_menu.items[0];
        console.log(firstInd);
        this.menu = this.phcApp.getMenu(firstInd);
        console.log(this.menu);
      }
    }
    console.log(this.menu);

  }

  allSlides: any = {};

  cycleSlides(slides: Slides) {
    console.log('init slides', slides);
    // slides.stopAutoplay();
    slides.autoplayDisableOnInteraction = false;
    clearInterval(this.allSlides[slides.id]);
    this.allSlides[slides.id] = setInterval(() => {
      slides.slideNext();
    }, 8000 + Math.round(1000 * Math.random()));
  }

  ngOnDestroy() {
    Object.keys(this.allSlides).forEach(key => {
      const interval = this.allSlides[key];
      clearInterval(interval);
    });
    this.sliderBackup.unsubscribe();
  }

  get version() {
    return window['APP_VERSION'] || '';
  }

  dims = {};

  videoDims(video: HTMLVideoElement) {
    if (!this.dims[video.src]) {
      this.dims[video.src] = { width: 'auto', height: 'auto' };
      video.onloadeddata = () => {
        const ratio = video.videoHeight / video.videoWidth;
        const width = 617;
        const height = ratio * width;
        console.log(width, height);
        this.dims[video.src] = { width: (width) + 'px', height: (height) + 'px', position: 'relative' };
      }
    }
    return this.dims[video.src];
  }

}



// WEBPACK FOOTER //
// ./src/pages/submenu/submenu.ts